<resource-list-grid>
    <resource-list-pane>
        <h2>Azure Entra SSO processing</h2>
    </resource-list-pane>
</resource-list-grid>